module.exports = __webpack_public_path__ + "img/edge_activites_pique_nique.4153a700.svg";